import {
  Tooltip,
  ActionIcon,
  useMantineTheme,
  rem,
  Popover,
  Stack,
  Group,
  Text,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useState } from "react";
import { InfoTooltipIcon } from "../../shared/svg/InfoTooltopIcon";
import { IconBulb } from "../../shared/svg/IconBulb";

interface UniversalTooltipProps {
  icon?: React.ReactNode;
  label: string;
  title?: string;
  zIndex?: number;
}

export function UniversalTooltip({
  icon,
  label,
  title,
  zIndex = 501,
}: UniversalTooltipProps) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery("(pointer: coarse)");
  const [opened, setOpened] = useState(false);

  const tooltipContent = (
    <Stack gap={6} p={0}>
      {title && (
        <Group gap={6}>
          <InfoTooltipIcon size={24} />
          <Text span fw={600} size="sm">
            {title}
          </Text>
        </Group>
      )}
      <Text size="sm" lh={1.4}>
        {label}
      </Text>
    </Stack>
  );

  const tooltipStyles = {
    borderRadius: rem(10),
    backgroundColor: theme.colors.violet[1],
    color: theme.black,
    padding: rem(12),
    boxShadow: theme.shadows.lg,
    border: `1px solid ${theme.colors.gray[3]}`,
    maxWidth: rem(300),
  };

  const renderedIcon = (
    <ActionIcon
      variant="light"
      size="sm"
      aria-label="Інформація"
      onClick={() => {
        if (isMobile) setOpened((o) => !o);
      }}
    >
      {icon || <IconBulb />}
    </ActionIcon>
  );

  if (isMobile) {
    return (
      <Popover
        opened={opened}
        onChange={setOpened}
        withArrow
        offset={6}
        position="top"
        zIndex={zIndex}
        styles={{
          dropdown: tooltipStyles,
          arrow: { backgroundColor: theme.colors.violet[1] },
        }}
      >
        <Popover.Target>{renderedIcon}</Popover.Target>
        <Popover.Dropdown>{tooltipContent}</Popover.Dropdown>
      </Popover>
    );
  }

  return (
    <Tooltip
      zIndex={zIndex}
      withArrow
      multiline
      position="top"
      offset={6}
      transitionProps={{ duration: 100, transition: "fade" }}
      styles={{
        tooltip: tooltipStyles,
        arrow: { backgroundColor: theme.colors.violet[1] },
      }}
      label={tooltipContent}
    >
      {renderedIcon}
    </Tooltip>
  );
}
